import { render } from "./LinkageSignup.vue?vue&type=template&id=f96499de&scoped=true&ts=true"
import script from "./LinkageSignup.vue?vue&type=script&lang=ts"
export * from "./LinkageSignup.vue?vue&type=script&lang=ts"

import "./LinkageSignup.vue?vue&type=style&index=0&id=f96499de&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1488180328/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96499de"]])

export default __exports__